import { format } from '@querodelivery/qd-date-helper';
import { moneyLabel } from '@/Utils/FnUtils';
import { EMissionType } from '../constants';

const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

const isMoneyField = (field: string) =>
  field === 'budget' || field.endsWith('rewardValue');

const isDateField = (field: string) =>
  field === 'startDate' || field === 'endDate';

const isDeliveriesField = (field: string) => field.endsWith('conditionValue');

const parseHistoryDate = (value: string | Date) => {
  if (value instanceof Date) return value;

  if (DATE_ONLY_PATTERN.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  return new Date(value);
};

const formatHistoryDate = (value: string | Date) => {
  const date = parseHistoryDate(value);
  if (Number.isNaN(date.getTime())) return String(value);

  const isDateOnly = typeof value === 'string' && DATE_ONLY_PATTERN.test(value);

  return format(date, isDateOnly ? 'dd/MM/yyyy' : 'dd/MM/yyyy HH:mm');
};

const formatDeliveriesValue = (value: number) =>
  `${value} ${value === 1 ? 'entrega' : 'entregas'}`;

const formatAudienceValue = (value: string) => {
  if (value === EMissionType.CITY) return 'Municípios';
  if (value === EMissionType.DELIVERYMAN) return 'Entregadores';
  return value;
};

const formatListValue = (value: unknown[]) =>
  value
    .map(item => {
      if (typeof item === 'string' || typeof item === 'number') {
        return String(item);
      }

      if (item && typeof item === 'object') {
        if ('name' in item && 'uf' in item) {
          return `${String(item.name)}/${String(item.uf)}`;
        }

        if ('name' in item) {
          return String(item.name);
        }
      }

      return String(item);
    })
    .join(', ');

export const formatMissionHistoryValue = (
  field: string,
  value: string | number | boolean | Date | unknown[] | null,
) => {
  if (value == null) return '';

  if (Array.isArray(value)) {
    return formatListValue(value);
  }

  if (isMoneyField(field) && typeof value === 'number') {
    return moneyLabel(value);
  }

  if (
    isDateField(field) &&
    (value instanceof Date || typeof value === 'string')
  ) {
    return formatHistoryDate(value);
  }

  if (isDeliveriesField(field) && typeof value === 'number') {
    return formatDeliveriesValue(value);
  }

  if (field === 'type' && typeof value === 'string') {
    return formatAudienceValue(value);
  }

  return String(value);
};
